import type { AppAlertTone } from "../components/AppAlertDialog";

export interface SuperAdminFeedback {
  message: string;
  title: string;
  tone: AppAlertTone;
}

export function businessApplicationFeedback(
  businessName: string,
  decision: "approve" | "reject",
): SuperAdminFeedback {
  return decision === "approve"
    ? {
        message: `${businessName} is approved and Business Owner access is now active.`,
        title: "Business Owner activated",
        tone: "success",
      }
    : {
        message: `${businessName} was returned for changes and remains inactive.`,
        title: "Application returned for changes",
        tone: "warning",
      };
}

export function businessPasswordResetFeedback(
  email: string,
  delivery: string,
): SuperAdminFeedback {
  return delivery === "sent"
    ? {
        message: `Password reset sent to ${email}.`,
        title: "Password reset sent",
        tone: "success",
      }
    : {
        message: `The reset was created, but email delivery is temporarily unavailable for ${email}.`,
        title: "Email delivery needs attention",
        tone: "warning",
      };
}
